<template>
    <div class ="simple-current-tariff">
        <div class="simple-current-tariff-text">
            <p><slot name="txtBefore"></slot></p>
            <p>{{tariffText}}</p>
        </div>
        <div class="simple-current-tariff-button">
            <a :href="link" class="btn btn-primary"><slot name="txtLink"></slot></a>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'SimpleCurrentTariffWrapper',
  components: { },
  data () {
    return {
      tariffs: {
        bookedTariff: {
          name: null,
          tariffId: null,
          basicFee: null

        }
      },
      link: './myfyve-uebersicht.html'
    }
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(gql`query bookedTariff {
        tariffs {
         bookedTariff {
           tariffId
           name
           basicFee
          }
        }
      }`, this, 'tariffs')
    }
  },
  mixins: [
    slotProxy(),
    transaction('bookedTariff')
  ],
  computed: {
    tariffText () {
      var tariff = this.tariffs.bookedTariff
      if (tariff.name === null) {
        return 'Du hast derzeit kein Tarif-Paket gebucht und nutzt den 9 Cent Basistarif'
      }
      return tariff.name
    }
  }

}
</script>
